import RenderableObject3D from '../core/RenderableObject3D'

export default class Mesh extends RenderableObject3D {
  constructor(geometry, material) {
    super(geometry, material);
  }
}
